import React from 'react';
import DraggableModal from 'components/DraggableModal';
import {DialogTypes} from 'common/names';
import {openDialogOutside} from 'common/openDialogOutside';
import SearchSynchronizationForm from 'features/layout/DialogRoutes/dialogs/synchronizations/SearchSynchronizationForm';

type SearchSynchronizationDialogProps = {
   onClose: () => void;
};

const SearchSynchronizationDialog = ({onClose}: SearchSynchronizationDialogProps) => {
   const openOutside = React.useCallback(
      () => openDialogOutside(DialogTypes.SearchSynchronizationDialog.id),
      []
   );

   return (
      <DraggableModal
         width={'md'}
         header={DialogTypes.SearchSynchronizationDialog.dialogName}
         onClose={onClose}
         onLaunch={openOutside}
      >
         <SearchSynchronizationForm onClose={onClose} />
      </DraggableModal>
   );
};

export default React.memo(SearchSynchronizationDialog);
